<template>
  <div class="card card-custom gutter-b" v-loading="loading">
    <div class="card-header d-flex justify-content-between">
      <div class="card-title">
        <h3 class="card-label">Quản lý công demo</h3>
      </div>
      <div class="card-title">
        <div class="dropdown dropdown-inline mr-2">
          <button type="button" @click="exportCongDemo" class="btn btn-warning font-weight-bolder mr-6">
            <i class="fa far fa-cloud-download p-0 mr-2"></i> Tải Công Demo
          </button>
          <button type="button" @click="exportAttendance" class="btn btn-success font-weight-bolder mr-6">
            <i class="fa far fa-file-import p-0 mr-2"></i> Import Công Demo
          </button>
          <button type="button" @click="importSubstitute = true" class="btn btn-primary font-weight-bolder mr-6">
            <i class="fa far fa-cloud-upload p-0 mr-2"></i> Import công dạy thay
          </button>
          <button type="button" @click="createAttendance" class="btn btn-light-primary font-weight-bolder">
            <i class="fa far fa-add p-0 mr-2"></i> Thêm mới công demo
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="example mb-10">
        <div class="row">
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <el-select v-model="query.center_ids" multiple filterable collapse-tags
                       placeholder="Chọn trung tâm"
                       @change="changeCenter" class="w-100">
              <el-option v-for="item in centers" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="col-sm-12	col-md-6 col-lg-4	col-xl-2 mt-5">
            <el-select v-model="query.branch_ids" multiple filterable collapse-tags
                       placeholder="Chọn chi nhánh"
                       @change="changeBranch" class="w-100">
              <el-option v-for="item in branches" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <el-select v-model="query.class_ids" multiple filterable collapse-tags
                       placeholder="Chọn lớp học" class="w-100">
              <el-option v-for="item in class_ids" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <el-select v-model="query.group_id" clearable filterable collapse-tags
                       placeholder="Chọn nhóm giảng viên"
                       @change="changeTeacher">
              <el-option v-for="item in listTeacherGroup" :key="item.id" :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <el-select v-model="query.teacher_ids" multiple filterable collapse-tags
                       placeholder="Chọn tên giảng viên"
                       @change="changeTeacher">
              <el-option v-for="item in teachers" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <button class=" btn btn-primary font-weight-bold mr-2"
                    @click="searchData">
              <i class="fa fa-search"></i> Tìm kiếm
            </button>
          </div>
        </div>
        <div class="example-preview table-responsive overflow-auto mt-3">
          <table class="table table-hover table-bordered table-vertical-center b-table"
                 style="text-align: center">
            <thead>
            <tr>
              <th scope="col" class="min-w-100px">Tên GV - Mã GV</th>
              <th scope="col" class="min-w-100px">Ngày học-Thời Gian</th>
              <th scope="col" class="min-w-100px">Cở sở dạy</th>
              <th scope="col" class="min-w-100px">Đơn giá</th>
              <th scope="col" class="min-w-100px">Hành động</th>
            </tr>
            </thead>
            <tbody>
            <ClassTimesheetItem v-for="item in classErrorList"
                                @getApi-class="getApiClass" :classError="item"
                                :key="item.id" :branches="branches" @updateWorkAttendance="callApiGetList">
            </ClassTimesheetItem>
            <tr v-if="classErrorList.length === 0 && !loading">
              <td colspan="9" class="event-title no-data">Chưa có dữ liệu</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="position-absolute" style="right:40px">
          Tổng số bản ghi: <b style="color:#3699FF">{{ total }}</b>
        </div>
      </div>
    </div>
    <div class="edu-paginate mx-auto text-center">
      <paginate v-model="page" :page-count="last_page" :page-range="3" :margin-pages="1"
                :click-handler="clickCallback"
                :prev-text="'Trước'" :next-text="'Sau'" :container-class="'pagination b-pagination'"
                :pageLinkClass="'page-link'" :next-link-class="'next-link-item'"
                :prev-link-class="'prev-link-item'"
                :prev-class="'page-link'" :next-class="'page-link'" :page-class="'page-item'">
      </paginate>
    </div>

    <!--  Modal Export Option -->
    <el-dialog v-if="is_dialog_create" :show-close="false" :visible.sync="is_dialog_create" width="40%">
      <div slot="title" style="display: flex; width: 100%; justify-content: space-between">
        <h3>Thêm mới công</h3>
        <i class="el-icon-close" style="cursor: pointer" @click="closeDialogCreate"></i>
      </div>
      <hr style="margin-top: -35px"/>
      <WorkRecordForm
          :branches="branches"
          @closeDialog="closeDialogCreate"
          @createSuccess="createWorkAttendance"
      />
    </el-dialog>
    <!--  Modal Export Option -->
    <el-dialog
      v-if="is_dialog_attendance"
      :title="hasErrors  ? 'Công trừ giáo viên' : 'Xem trước khi import công trừ'" @close="closeDialog"
      :visible.sync="is_dialog_attendance"
      :width="hasErrors ? '50%' : '30%'"
  >
    <hr style="margin-top: -20px"/>
    <ImportClassTimeSheet @errors="setHasErrors" @closeDialog="closeDialog"/>
  </el-dialog>
    <el-dialog
        v-if="importSubstitute"
        :title="hasErrors ? 'Xem trước khi import công giáo viên dạy thay' : 'Công giáo viên dạy thay'" @close="closeDialogSubstitute"
        :visible.sync="importSubstitute"
        :width="hasErrors ? '50%' : '30%'"
    >
      <hr style="margin-top: -20px"/>
      <ImportClassTimeSheetSubstitute @errors="setHasErrors" @closeDialog="closeDialogSubstitute"/>
    </el-dialog>
  </div>
</template>
<script>

import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import ClassTimesheetItem from "./components/ClassTimesheetItem.vue";
import {GET_CENTERS} from "@/core/services/store/center/centers.module";
import {GET_BRANCHES} from "@/core/services/store/center/branch.module";
import {
  EXPORT_ERROR_CLASSROOM,
  GET_TEACHERS_OR_TUTORS,
  EXPORT_ERROR_CLASSROOM_STUDENT,
  CLASS_TIMESHEETS,
} from "@/core/services/store/course/classes.module";
import {GET_COURSES_LIST} from "@/core/services/store/course/course.module";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {
  exportExcel,
  HEADER_ROW_EXPORT_ERROR_LIST_STUDY_TURN,
  HEADER_ROW_EXPORT_ERROR_LIST_STUDENT
} from "@/core/filters";
import DialogConfirmExportCertificate from "./components/DialogConfirmExportCertificate.vue";
import {GET_TEACHER_GROUPS} from "@/core/services/store/teacher/teacher.module";
import TableImportError from "../tax-invoice/components/TableImportError.vue";
import TableImportErrorGlobal from "./TableImportErrorGlobal.vue";
import WorkRecordForm from "@/view/pages/classes/components/WorkRecordForm.vue";
import ImportClassTimeSheet from "@/view/pages/classes/components/ImportClassTimeSheet.vue";
import {EXPORT_CLASS_TIMESHEETS} from "@/core/services/store/export/export.module";
import ImportClassTimeSheetSubstitute from "@/view/pages/classes/components/ImportClassTimesheetSubstitute.vue";

export default {
  components: {
    ImportClassTimeSheetSubstitute,
    ImportClassTimeSheet,
    WorkRecordForm,
    TableImportErrorGlobal,
    TableImportError,
    DialogConfirmExportCertificate,
    ClassTimesheetItem,
    DatePicker
  },

  name: "manageClass",
  data() {
    return {
      query: {
        center_ids: [],
        branch_ids: [],
        course_ids: [],
        class_name: '',
        teacher_ids: [],
        class_ids: [],
        date_range: [],
        group_id: ''
      },
      title: 'Công trừ giáo viên',
      uploading: false,
      disable: false,
      progress: 0,
      listCertificate: [],
      oneClassList: {},
      classErrorList: [],
      centers: [],
      center_ids: [],
      branches: [],
      teachers: [],
      courses: [],
      class_ids: [],
      is_disable_search: false,
      last_page: 1,
      page: 1,
      total: 0,
      is_disable_export: false,
      is_dialog_create: false,
      is_dialog_attendance: false,
      type_export: 1,
      loading: false,
      isCertificate: false,
      download_default: false,
      listTeacherGroup: [],
      startImport: true,
      hasErrors: false,
      importSubstitute: false,
      titleSubstitute: ''
    };
  },

  async mounted() {
    await this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Quản lý công demo"},
      {title: "Quản lý dạy học"},
    ]);
    await this.getCenters();
    this.getBranches();
    this.getTeachers();
    this.callApiGetList();
    this.getTeacherGroups();
  },

  methods: {
    changeCenter() {
      this.getClasses();
    },
    changeBranch() {
      this.getClasses();
      this.callApiGetList();
    },
    changeTeacher() {
      this.getClasses();
      this.callApiGetList();
    },
    createAttendance() {
      this.is_dialog_create = true;
    },
    exportAttendance() {
      this.is_dialog_attendance = true;
    },
    closeDialog() {
      this.is_dialog_attendance = false
      this.isCertificate = false
      this.is_disable_export = false
      this.type_export = 1
    },
    closeDialogSubstitute() {
      this.importSubstitute = false
    },
    setHasErrors(value) {
      this.hasErrors = value
    },
    exportData() {
      this.is_disable_export = true;
      switch (this.type_export) {
        case 1:
          this.exportStudentList();
          break
        case 2:
          this.exportStudySession();
          break;
        case 3:
          this.isCertificate = true;
          break
        default:
          return;
      }
    },
    closeDialogCreate() {
      this.is_dialog_create = false
    },

    async exportStudentList() {
      let data_student;
      await this.$store.dispatch(EXPORT_ERROR_CLASSROOM_STUDENT, {
        ...this.query,
      }).then((res) => {
        data_student = res.data;
      }).finally(() => {
        this.is_disable_export = false;
        this.is_dialog_option = false;
      });
      exportExcel(HEADER_ROW_EXPORT_ERROR_LIST_STUDENT, data_student, "Danh sách học viên.xlsx", false)
    },
    async exportStudySession() {
      let data_study;
      await this.$store.dispatch(EXPORT_ERROR_CLASSROOM, {
        ...this.query,
      }).then((res) => {
        data_study = res.data;
      }).finally(() => {
        this.is_disable_export = false;
        this.is_dialog_option = false;
      });
      exportExcel(HEADER_ROW_EXPORT_ERROR_LIST_STUDY_TURN, data_study, "Danh sách lượt học.xlsx", false)
    },
    clickCallback(obj) {
      this.page = obj
      this.$router.push({
        name: 'manage-error',
        query: {
          page: this.page,
          ...this.query
        }
      })
      this.callApiGetList()
    },
    pushParamsUrl() {
      this.$router.push({
        name: 'class-timesheets',
        query: {
          page: this.page,
          ...this.query
        }
      })
    },
    searchData() {
      this.page = 1
      this.is_disable_search = true
      this.pushParamsUrl()
      this.callApiGetList()
    },
    callApiGetList() {
      this.loading = true
      let payload = {};
      payload = {...this.query, page: this.page}
      if (payload.center_ids.length === 0) {
        payload = {...payload, center_ids: this.center_ids}
      }
      this.$store.dispatch(CLASS_TIMESHEETS, payload).then((res) => {
        if (!res.error) {
          this.classErrorList = res.data?.data ?? res.data;
          this.last_page = res.last_page ?? res.pagination.last_page;
          this.total = res.total ?? res.pagination.total;
          this.is_disable_search = false;
        }
      }).catch(e => {
        console.log(e)
      }).finally(() => this.loading = false);
    },
    async getClasses() {
      this.query.class_ids = [];
      let payload = {};
      payload = {...this.query, page: this.page}
      if (payload.center_ids.length == 0) {
        payload = {...payload, center_ids: this.center_ids}
      }
      await this.$store.dispatch(CLASS_TIMESHEETS, payload).then((res) => {
        if (!res.error) {
          this.class_ids = res.data;
        }
      });
    },
    exportCongDemo() {
      this.download_default  = true
      this.$store.dispatch(EXPORT_CLASS_TIMESHEETS).then((res) => {
        this.download_default = false
        this.$notify({
          title: 'Thành công',
          message: res.message,
          type: 'success'
        })
      }).catch((error) => {
        this.download_default = false
        this.$notify({
          title: 'Thất bại',
          message: error.data.message,
          type: 'error'
        })
      })
    },
    getApiClass(nameClass) {
      this.oneClassList = this.classList[0];
    },

    // lấy API tất cả các trung tâm
    getCenters() {
      return this.$store.dispatch(GET_CENTERS, {is_edutalk: '1'}).then((res) => {
        if (!res.error) {
          for (let dataKey in res.data.data) {
            this.center_ids.push(res.data.data[dataKey].id);
            this.centers.push({
              id: res.data.data[dataKey].id,
              name: res.data.data[dataKey].name,
            });
          }
        }
      });
    },

    // lấy API tất cả các giảng viên
    getTeachers() {
      return this.$store
          .dispatch(GET_TEACHERS_OR_TUTORS, {
            limit: 10000,
            is_teacher: 1,
            center_ids: this.query.center_ids.length > 0 ? this.query.center_ids : this.center_ids
          })
          .then((res) => {
            if (!res.error) {
              this.teachers = res.data;
            }
          })
          .catch((e) => {
            console.log(e, "error");
          });
    },

    // lấy API tất cả các chi nhánh
    getBranches() {
      return this.$store
          .dispatch(GET_BRANCHES, {
            limit: 10000,
            status: 1,
            center_ids: this.query.center_ids.length > 0 ? this.query.center_ids : this.center_ids
          })
          .then((res) => {
            if (!res.error) {
              this.branches = res.data.data;
            }
          });
    },

    // lấy API tất cả các khoá học
    getCourses() {
      return this.$store
          .dispatch(GET_COURSES_LIST, {
            limit: 10000,
            status: 1,
            center_ids: this.query.center_ids.length > 0 ? this.query.center_ids : this.center_ids
          })
          .then((res) => {
            if (!res.error) {
              this.courses = res.data;
              // this.setCacheTheLoad()
            }
          })
          .catch((e) => {
            console.log(e, "error");
          });
    },
    getTeacherGroups() {
      this.$store.dispatch(GET_TEACHER_GROUPS).then((data) => {
        this.listTeacherGroup = data.data
        this.listTeacherGroup.splice(0, 0, {id: 0, name: '(Không có nhóm)'})
      })
    },
    createWorkAttendance() {
      this.is_dialog_create = false
      this.callApiGetList()
    },
  },
};
</script>
<style lang="scss" scoped></style>
